import styled, { css } from "styled-components";
import { Button as rButton } from "react-bootstrap";

const disabledStyle = css`
  background-color: #e6e9ec !important;
  border-color: #e6e9ec !important;
  opacity: 1;
  cursor: not-allowed;
`;

const Button = styled(rButton)`
  border-radius: 0;
  font-weight: 600;
  min-width: 8rem;
  margin-top: 1rem;
  margin-right: 1rem;
  min-height: 3rem;
  font-size: 1.1rem;
  border: 0;

  ${(props) =>
    props.primary &&
    css`
      background-color: ${(props) => props.theme.button.backgroundColor};
      border-color: ${(props) => props.theme.button.borderColor};

      &:active,
      &:hover,
      &:focus {
        background-color: ${(props) =>
          props.theme.button.backgroundColor} !important;
        border-color: ${(props) => props.theme.button.borderColor} !important;
      }
    `}

  &:disabled {
    ${disabledStyle}

    &:hover {
      ${disabledStyle}
    }
  }
`;

export default Button;
